import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import CookiePreferencesModal from './CookiePreferencesModal';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);

    console.log('CookieConsent from footer app');

    useEffect(() => {
        // Check if user has already made a choice
        const cookieConsent = localStorage.getItem('cookieConsent');
        const cookiePreferences = localStorage.getItem('cookiePreferences');

        let shouldShowPopup = true;

        if (cookieConsent && cookiePreferences) {
            try {
                const prefs = JSON.parse(cookiePreferences);
                // Only hide popup if essential is true (user has given consent)
                shouldShowPopup = prefs.essential !== true;
            } catch (err) {
                console.error('Error parsing cookie preferences:', err);
                shouldShowPopup = true;
            }
        }

        if (shouldShowPopup) {
            // Show popup after a short delay for better UX
            setTimeout(() => setIsVisible(true), 1000);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        localStorage.setItem('cookiePreferences', JSON.stringify({ essential: true, analytics: true, marketing: true }));
        setIsVisible(false);
        // Dispatch custom event to notify ClientScripts
        window.dispatchEvent(new CustomEvent('cookiePreferencesChanged'));
    };

    const handlePreferences = () => {
        setShowPreferences(true);
    };

    const handleSavePreferences = (preferences: { analytics: boolean; marketing: boolean; essential: boolean }) => {
        localStorage.setItem('cookieConsent', 'preferences');
        localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
        setIsVisible(false);
        // Dispatch custom event to notify ClientScripts
        window.dispatchEvent(new CustomEvent('cookiePreferencesChanged'));
    };

    const _handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <>
            <div id="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-[999999999] bg-background border border-border rounded-lg shadow-lg p-4 animate-in slide-in-from-bottom-2">
                <div className="space-y-3">
                    <p id="cookie-banner-description" className="text-sm text-foreground leading-relaxed">
                        We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.{' '}
                        <a id="cookie-banner-privacy-link" href="/privacy-policy" className="text-primary hover:underline">
                            Read Privacy Policy
                        </a>
                        .
                    </p>
                    <div className="flex gap-2">
                        <Button
                            id="cookie-banner-accept-all"
                            onClick={handleAccept}
                            className="flex-1 bg-primary text-primary-foreground hover:bg-primary/90"
                            size="sm"
                        >
                            Accept All
                        </Button>
                        <Button
                            id="cookie-banner-preferences"
                            onClick={handlePreferences}
                            variant="outline"
                            className="flex-1"
                            size="sm"
                        >
                            Preferences
                        </Button>
                    </div>
                </div>
            </div>

            {/* Preferences Modal */}
            <CookiePreferencesModal
                isOpen={showPreferences}
                onClose={() => setShowPreferences(false)}
                onSavePreferences={handleSavePreferences}
            />
        </>
    );
};

export default CookieConsent;
